import {
    POST,
    postFile,
    GET,
} from "../../index";
export const DriverFingerprint = (param) => POST("/v1/FingerPrintLibrary/findAllDriverAndFingerNum", param);
export const insertDriverFinger = (param) => POST("/v1/FingerPrintLibrary/insertDriverFinger", param);
export const FingerprintLibraryList = (param) => POST("/v1/fingerWarehouse/selectFingerWarehouseList", param);
export const insertFingerprintLibrary = (param) => POST("/v1/fingerWarehouse/insertFingerWarehouse", param);
export const updateFingerprintLibrary = (param) => POST("/v1/fingerWarehouse/updateFingerWarehouse", param);
export const deleteFingerprintLibrary = (param) => POST("/v1/fingerWarehouse/deleteFingerWarehouse", param);
export const transferFingerprintLibrary = (param) => POST("/v1/fingerWarehouse/transferFingerWarehouse", param);
export const selectPrintLibraryList = (param) => POST("/v1/fingerWarehouse/selectFingerWarehouseCarList", param);
export const selectCheckedDriver = (param) => POST("/v1/fingerWarehouse/selectCheckedDriver", param);

export const selectFingerList = (param) => POST("/v1/FingerPrintLibrary/selectFingerList", param);
export const IssueFingerToCarList = (param) => POST("/v1/FingerPrintLibrary/IssueFingerToCarList", param);
export const selectAllFingerByCar = (param) => POST("/v1/FingerPrintLibrary/selectAllFingerByCar", param);
export const deleteByDriverNum = (param) => POST("/v1/FingerPrintLibrary/deleteByDriverNum", param);
export const deleteDriverFinger = (param) => POST("v1/FingerPrintLibrary/deleteDriverFinger", param);

export const selectDriverFinger = (param) => POST("/v1/driverFinger/selectDriverFinger", param);
export const selectDriverFingerList = (param) => POST("/v1/driverFinger/selectDriverFingerList", param);
export const clearDriverFinger = (param) => POST("/v1/driverFinger/clearDriverFinger", param);
export const delDriverFinger = (param) => POST("/v1/driverFinger/deleteDriverFinger", param);
export const addDriverFinger = (param) => POST("/v1/driverFinger/insertDriverFinger", param);